export default {
  noResults: 'No results'
};